import styled from "styled-components";
import { NarrowContentWrap } from "components/AppLayout/AppLayout.styled";

export const CertificatesFileUploaderWrapper = styled(NarrowContentWrap)`
  position: relative;
`;
